// export const API_URL = process.env.REACT_APP_API_URL!
export const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID!
// export const API_URL = "http://192.168.1.46:3008"
export const API_URL = "https://airvis-api.airdata.site/avis"
